import React, { useEffect, useLayoutEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

// Components
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import LLMSnippet from "./components/LLMSnippet";
import HowWeHelp from "./components/HowWeHelp";
import About from "./components/About";
import ServiceAreas from "./components/ServiceAreas";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import LLMAnswerMetadata from "./components/SEO/LLMAnswerMetadata";
import SubdomainRedirect from "./components/SubdomainRedirect";
import { Toaster } from 'sonner';

// Pages
import LocationsPage from "./pages/LocationsPage";
import ServicesPage from "./pages/ServicesPage";
import SellYourHomePage from "./pages/SellYourHomePage";
import RenovationPage from "./pages/RenovationPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsAndConditionsPage from "./pages/TermsAndConditionsPage";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
};

// Home Page Component
const HomePage = () => {
  useEffect(() => {
    // Intersection Observer for grid pattern visibility on scroll
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('grid-visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    // Observe all sections with grid-pattern class
    document.querySelectorAll('.grid-pattern').forEach((section) => {
      observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Services />
        <LLMSnippet />
        <HowWeHelp />
        <About />
        <ServiceAreas />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <HelmetProvider>
      <LLMAnswerMetadata />
      <Toaster position="top-right" richColors />
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <SubdomainRedirect />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/sell-your-home" element={<SellYourHomePage />} />
            <Route path="/renovation" element={<RenovationPage />} />
            <Route path="/locations" element={<LocationsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
